import common from '@/public/common'
import { ajaxApi} from '@/server'

/**
 * 获取品牌渠道集合
 * @returns 
 */
export async function getBrandList () {
  try {
    const res = await ajaxApi(`${common.javaBase_url}brandwx/qrcode/brandlist`)
    if (res.status === 200 && res.data) {
      return res.data
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

/**
 * 获取社群会员列表
 * @param {*} params 
 * @returns 
 */
export async function getQrcodeList (params) {
  try {
    const res = await ajaxApi(`${common.javaBase_url}brandwx/qrcode/list`, {...params})
    if (res.status === 200 && res.data) {
      return res.data
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

/**
 * 修改企微活码
 * @param {*} params 
 * @returns 
 */
export async function updateQrCode (params) {
  try {
    const res = await ajaxApi(`${common.javaBase_url}brandwx/qrcode/update`, {...params})
    if (res.status === 200 && res.data) {
      return res.data
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

/**
 * 添加企微活码
 * @param {*} params 
 * @returns 
 */
export async function addQrCode (params) {
  try {
    const res = await ajaxApi(`${common.javaBase_url}brandwx/qrcode/add`, {...params})
    if (res.status === 200 && res.data) {
      return res.data
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

export async function deleteQrCode (params) {
  try {
    const res = await ajaxApi(`${common.javaBase_url}brandwx/qrcode/delete`, {...params})
    if (res.status === 200 && res.data) {
      return res.data
    }
  } catch (error) {
    console.log(error)
  }
  return null
}


// WEBPACK FOOTER //
// ./src/pages/brandwx/service.js